export const createGroupId = name =>
  (name || '').toLowerCase().replace(/\s+/g, '-')
